import React, { useState, useEffect, useRef } from 'react';
import { FaEllipsisV, FaUserShield, FaUser, FaTrash, FaEdit } from 'react-icons/fa';
import { getPrimaryRole, isSuperAdminUser } from '../../utils/roleUtils';
import './ActionMenu.css';

const ActionMenu = ({ emp, user, onEdit, onDelete, onRoleChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const isSelf = emp.email === user.email;
    const isCurrentUserSuperAdmin = isSuperAdminUser(user);
    const targetPrimaryRole = getPrimaryRole(emp);
    const targetIsSuperAdmin = targetPrimaryRole === "Super Admin";

    return (
        <div className="action-menu-container" ref={menuRef}>
            <button
                className="action-btn edit"
                onClick={() => onEdit(emp)}
                title="Edit User"
            >
                <FaEdit /> Edit
            </button>

            <button
                className="action-menu-trigger"
                onClick={() => setIsOpen(!isOpen)}
                title="More Actions"
            >
                <FaEllipsisV />
            </button>

            {isOpen && (
                <div className="action-dropdown">
                    {isCurrentUserSuperAdmin && (
                        <button
                            className="action-dropdown-item"
                            onClick={() => { window.location.href = '/roles'; }}
                        >
                            <FaUserShield /> Advanced Role Setup
                        </button>
                    )}

                    {!targetIsSuperAdmin && targetPrimaryRole === "Admin" ? (
                        <button
                            className="action-dropdown-item"
                            onClick={() => { onRoleChange(emp, "Employee"); setIsOpen(false); }}
                            disabled={isSelf}
                        >
                            <FaUser /> Demote to User
                        </button>
                    ) : !targetIsSuperAdmin ? (
                        <button
                            className="action-dropdown-item success"
                            onClick={() => { onRoleChange(emp, "Admin"); setIsOpen(false); }}
                        >
                            <FaUserShield /> Promote to Admin
                        </button>
                    ) : null}

                    <div className="action-divider"></div>

                    <button
                        className="action-dropdown-item danger"
                        onClick={() => { onDelete(emp); setIsOpen(false); }}
                        disabled={isSelf || (!isCurrentUserSuperAdmin && targetIsSuperAdmin)}
                    >
                        <FaTrash /> Delete User
                    </button>
                </div>
            )}
        </div>
    );
};

export default ActionMenu;
